














import Vue from 'vue'
import { ActionInterface, PlusLinkElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'PlusLinkEl',
  props: {
    templateItemData: {
      type: Object as () => PlusLinkElInterface,
      required: true
    }
  },
  computed: {
    mainStyle (): string {
      return this.templateItemData.align
        ? 'text-align: ' + this.templateItemData.align + ';'
        : ''
    },
    separatorStyle (): string {
      return 'border-bottom: 2px solid ' + this.templateItemData.separator + ';'
    }
  },
  methods: {
    handleActionClick (action: ActionInterface): void {
      if (action && action.uri !== undefined) {
        this.getView(action.view, action.content || action.uri, null, action.jumpOnCloseUri)
      }
    }
  }
})
